/*!
 * Manera Main
 * 
 */
$(document).ready(function() {

    /**COokie **/
    var visitedPage = Cookies.get('nloverlay');
    if (visitedPage == "NaN" || visitedPage == "undefined")
        visitedPage = 0;
    if (visitedPage < 2)
        visitedPage++;
    Cookies.set('nloverlay', visitedPage);

    if (visitedPage == 2)
        $('.nl__popup').addClass('active');

    $('.nl__popup').find('.popup_close, .button').on('click', function () {
        var pagecount = Cookies.get('nloverlay');
        pagecount++;
        Cookies.set('nloverlay', pagecount);
        $('.nl__popup').removeClass('active');
    });

    //menu
    $('.computer .header .level_1>.submenu, .computer .toggle_search').hover(function () {
        $('.header').addClass('hover');
    }, function () {
        $('.header').removeClass('hover');
    });

    /** GO TO TOP **/
    $('.gototop').on('click', function (e) {
        e.preventDefault();
        TweenMax.to(window, 2, {scrollTo: "#top"});
    });

    //anim go to top
    TweenMax.to($('.gototop .circle'), .5, {
        x: "20px",
        repeat: -1,
        yoyo: true
    });

    //sticky header
    //if (!$('body').hasClass('mobile')) {
        var headerController = new ScrollMagic.Controller();
        var ch = $('.cookiebar:visible').outerHeight();
/*console.log(ch);
        if (ch > 0)
            var offset = -ch;
        else
            var offset = 1;
*/
        var offset = 1;
        var stickyScene = new ScrollMagic.Scene({
            triggerElement: '#top',
            triggerHook: "onLeave",
            offset: offset,
        }).setClassToggle('.header', 'sticky').setPin('.header').addTo(headerController);

    $('.cookiebar').find('.button').on('click',function(e){
        $('.header').css('top',0);
        stickyScene.refresh();
    });

    $('#navbar').on('show.bs.collapse', function () {
        $('.header').addClass('full');
        $('body').addClass('fixed');
        $('.header__findstore').addClass('d-none');
        $('.header__changelanguage').addClass('d-block');
        $('.toggle_search').removeClass('active');

    })
    $('#navbar').on('hide.bs.collapse', function () {
        $('body').removeClass('fixed');
        $('.header').removeClass('full');
        $('.header__findstore').removeClass('d-none');
        $('.header__changelanguage').removeClass('d-block');
    });

    $('.level_1').find('a.noclic').on('click',function(e){
        e.preventDefault();
    });

    /*** HOME ***/
    $('.home__news--block2 .links a').on('click',function(e){
        //affichage du menu men/women
        $('.home__news--block2 .links').find(':not(.active)').addClass('active');
        $(this).parent().removeClass('active');

        //changement bg
        var genre = $(this).parent().data('link');
        $('.bg').removeClass('active');
        $("[data-bg='"+genre+"']").addClass('active');

        //changement combi
        //$('.combinaisons').find('li.active').addClass('animating');
        $('.wetsuit').removeClass('active');
        $("[data-genre='"+genre+"']").addClass('active');
        $('.home__news--block2 .content').find('.button').addClass('d-none');
        $('.home__news--block2 .content').find('.'+genre).removeClass('d-none');

    });
    $('.home_explore').hover(function(){
        $('.arrow-holder').addClass('hovered');
    },function(){
        $('.arrow-holder').removeClass('hovered');
    });
    $('.home_explore').on('click',function(e){
        e.preventDefault();
        TweenMax.to(window,1, {scrollTo:".home_title"});
    })
    //vimeo fiche produit
    if($('.video_wrapper').length > 0){

        var iframe = document.querySelector('iframe');
        var player = new Vimeo.Player(iframe);

        $('.video_wrapper .play').on('click',function(e){
            $('.first_image').fadeOut('slow');
            $(this).fadeOut("slow", function(){
                player.play();
            });

        });
    }

    /** parallax handled with data-atrributes**/
    if($('.paroller').length > 0) {

        //$('.paroller').paroller();
    }
});//FIN DOM READY

if("matchMedia" in window) {
    if(window.matchMedia("(max-width:991.98px)").matches) {
        //console.log('max-width 991');
        var faccordion = $('#footer').find('.footer_accordion');

        faccordion.each(function(){
            var toggler =  $(this).find('h2');
            var $this = $(this);
            var smenu = $this.find('.inner');
            toggler.on('click', function(){
                toggler.toggleClass('active');
                smenu.toggleClass('active');
            })
        })

        $('.toggle_search a').on('click',function(){
            $(this).parent().toggleClass('active');
            $('.collapse').collapse('hide');
        })
    };

    var matchesIpad = window.matchMedia("(orientation:landscape)").matches;
    if(matchesIpad)
    {
        $('.toggle_search a').on('click',function(){
            $(this).parent().toggleClass('active');
            $('.collapse').collapse('hide');
        })
    }
}
window.addEventListener('resize', resize, false);

function resize() {
    if("matchMedia" in window) { // Détection
        if(window.matchMedia("(max-width:991.98px)").matches) {
           if($('#filtres').length > 0){
               $("#filres h2").on('click',function(e){
                   $(this).addClass('active');
               });
           }
            if($('.portrait').length > 0) {

                var picture = $('.portrait').find('.image_container');
                var socialPos = picture.position().top + picture.height();
                $('.athlete__socials').css('top', socialPos + 50);
            }
        }
    }
}